import toast, { ToastOptions } from "react-hot-toast"
import { useTranslation } from "react-i18next"

const useToast = () => {
  const { t } = useTranslation()

  const error = (id: string, options?: ToastOptions) => {
    toast.remove()
    toast.error(t(id), options)
  }

  const success = (id: string, options?: ToastOptions) => {
    toast.remove()
    toast.success(t(id), options)
  }

  return {
    error,
    success,
  }
}

export { useToast }
